import * as types from "./statusKerjasama.actionTypes";
import { action, createAsyncAction } from "typesafe-actions";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { StatusKerjasama } from "../../interfaces/StatusKerjasama";
import { StatusKerjasamaCreateResponse, StatusKerjasamaDetailResponse, StatusKerjasamaListResponse, StatusKerjasamaUpdateResponse } from "./types";

export const selectStatusKerjasama = (statusKerjasama: StatusKerjasama | null) => action(types.SELECT_STATUS_KERJASAMA, { statusKerjasama });

export const updateName = (name: string) => action(types.UPDATE_NAME, { name });

export const updateStatus = (status: number) => action(types.UPDATE_STATUS, { status });

export const initializeCreateStatusKerjasama = () => {
  const statusKerjasama: StatusKerjasama | null = {
    STATUS_ID: 0,
    STATUS_NAME: '',
    STATUS: 1
  }

  return action(types.INITIALIZE_CREATE_STATUS_KERJASAMA, { statusKerjasama })
}

export const getStatusKerjasamaAsync = createAsyncAction(
  types.GET_STATUS_KERJASAMA_REQUEST,
  types.GET_STATUS_KERJASAMA_SUCCESS,
  types.GET_STATUS_KERJASAMA_FAILURE
)<{ status?: number }, StatusKerjasamaListResponse, ErrorResponse>();

export const getDetailStatusKerjasamaAsync = createAsyncAction(
  types.GET_DETAIL_STATUS_KERJASAMA_REQUEST,
  types.GET_DETAIL_STATUS_KERJASAMA_SUCCESS,
  types.GET_DETAIL_STATUS_KERJASAMA_FAILURE
)<{ id: number }, StatusKerjasamaDetailResponse, ErrorResponse>();

export const updateStatusKerjasamaAsync = createAsyncAction(
  types.UPDATE_STATUS_KERJASAMA_REQUEST,
  types.UPDATE_STATUS_KERJASAMA_SUCCESS,
  types.UPDATE_STATUS_KERJASAMA_FAILURE
)<StatusKerjasama, StatusKerjasamaUpdateResponse, ErrorResponse>();

export const createStatusKerjasamaAsync = createAsyncAction(
  types.CREATE_STATUS_KERJASAMA_REQUEST,
  types.CREATE_STATUS_KERJASAMA_SUCCESS,
  types.CREATE_STATUS_KERJASAMA_FAILURE
)<StatusKerjasama, StatusKerjasamaCreateResponse, ErrorResponse>();
